import {array, lazy, object, string} from 'yup'

import type {AppConfig} from '../types'
import {FieldName, routeDestinationPrefixName, routeReturnName, routeSourceName} from './fieldNames'

/**
 * Схема валидации фронтовых компонентов формы заказа.
 * @param i18n Функция для получения перевода по ключу
 * @param config Конфиг приложения
 * @returns Правила валидации
 */
export const getFormValidationSchema = (i18n: (key: string) => string, config: AppConfig) => {
  return object({
    [FieldName.Ndd]: object().when('selected_submode', {
      is: (value: string) => value === 'ndd_self_pickup',
      then: schema =>
        schema.shape({
          route: object({
            source: object({
              pickupPoint: object().required(i18n('validation.required')),
              phone: string()
                .required(i18n('validation.required'))
                .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
            }),
            destination: object({
              pickupPoint: object().required(i18n('validation.required')),
              phone: string()
                .required(i18n('validation.required'))
                .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
            }),
          }),
        }),
      otherwise: schema => schema.optional(),
    }),
    [FieldName.Route]: object().when('selected_submode', {
      is: (value: string) => value !== 'ndd_self_pickup',
      then: lazy(obj =>
        object({
          ...Object.keys(obj || {}).reduce((acc, key) => {
            acc[key] = key.startsWith(routeDestinationPrefixName) // адреса итерируются через значение в ключе: destination_${iteration}
              ? object({
                  address: object({
                    title: string().required(i18n('validation.required')),
                  }),
                })
              : undefined

            return acc
          }, {}),
          [routeReturnName]: object({
            address: object({
              title: string(),
              // валидируем телефон, только если выбран адрес
              phone: string().when('title', {
                is: (title?: string) => {
                  return typeof title === 'string' && title.length > 0
                },
                then: string()
                  .required(i18n('validation.required'))
                  .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
              }),
            }),
          }),
          [routeSourceName]: object({
            address: object({
              title: string().required(i18n('validation.required')),
            }),
          }),
        }),
      ),
      otherwise: schema => schema.optional(),
    }),
    [FieldName.Contacts]: array().when('selected_submode', {
      is: (value: string) => value !== 'ndd_self_pickup',
      then: array(
        object({
          phone: string()
            .required(i18n('validation.required'))
            .test('phone', i18n('validation.phone.invalid'), config.checkIsValidPhone),
        }),
      )
        .default([{phone: ''}, {phone: ''}])
        .required(i18n('validation.required')),
      otherwise: schema => schema.optional(),
    }),
  })
}
